import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import Client from './client';

export const useAuth = (
  options: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof Client.auth>>,
      Error,
      Parameters<typeof Client.auth>[0],
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const { mutateAsync, status } = useMutation({
    mutationFn: Client.auth,
    ...options,
  });

  return {
    authMutateAsync: mutateAsync,
    authStatus: status,
  };
};
